import { Controller } from 'stimulus'
import SimpleParallax from 'simple-parallax-js/vanilla'

export default class extends Controller {
  static values = {
    customWrapperSelector: String, // Always pass this. e.g. selector of the parent element. the library we use does this.element.closest(selector)
    scale: Number, // If the parallaxed content is an image, render the image at a higher resolution (resolution you want to render at * scale)
  }

  connect() {
    if (!this.customWrapperSelectorValue) {
      throw new Error(
        "You must provide a customWrapperSelector. This is ugly but the way stimulus works, you must provide this. Otherwise, we'll get stuck in an infinite connect/disconnct loop. You can give this element's parent a selector and pass that here."
      )
    }

    this.instance = new SimpleParallax(this.element, {
      customWrapper: this.customWrapperSelectorValue,
      scale: this.scaleValue,
    })
  }

  disconnect() {
    this.instance.destroy()
  }
}
